import { render, staticRenderFns } from "./NewsDetailPage.vue?vue&type=template&id=5a27f3ee&scoped=true"
import script from "./NewsDetailPage.vue?vue&type=script&lang=js"
export * from "./NewsDetailPage.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailPage.vue?vue&type=style&index=0&id=5a27f3ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a27f3ee",
  null
  
)

export default component.exports